<template>
  <div class="map-container">
    <div id="fengmap"></div>
    
    <!-- 路线规划控制面板 -->
    <div class="panel">
      <div class="panel-header">
        <span :class="{ active: naviMode === 1 }" @click="naviMode = 1">路线规划</span>
        <span :class="{ active: naviMode === 2 }" @click="naviMode = 2">模拟导航</span>
      </div>
      
      <div class="panel-content" v-if="naviMode === 1">
        <div class="start-end-input">
          <div class="input-group">
            <div class="dot start"></div>
            <input v-model="startName" placeholder="请点击地图选择起点" readonly />
          </div>
          <div class="input-group">
            <div class="dot end"></div>
            <input v-model="endName" placeholder="请点击地图选择终点" readonly />
          </div>
          <div class="exchange-btn" @click="exchangeStartEnd" title="交换起终点">⇅</div>
        </div>
        
        <div class="action-buttons">
          <button class="btn clear" @click="clearAll">清除路线</button>
          <button class="btn search" @click="handleStartSimulation" :disabled="!hasRoute" :style="{ opacity: !hasRoute ? 0.6 : 1 }">模拟导航</button>
        </div>
        
        <div class="route-info" v-if="routeDescription">
          {{ routeDescription }}
        </div>
      </div>
      <div class="panel-content" v-if="naviMode === 2">
          <div class="navi-controls">
              <div class="status-text" v-if="!isNaviRunning && !hasRoute" style="margin-bottom: 15px; color: #e6a23c; font-size: 14px;">请先在"路线规划"模式下规划路线</div>
              <div class="status-text" v-else-if="!isNaviRunning" style="margin-bottom: 15px; color: #67c23a; font-size: 14px;">准备就绪，点击开始进行导航</div>
              <div class="status-text" v-else style="margin-bottom: 15px; color: #409eff; font-size: 16px; font-weight: bold;">{{ naviInstruction || '导航中...' }}</div>
              
              <div class="action-buttons">
                  <button class="btn search" @click="startSimulation" :disabled="isNaviRunning || !hasRoute" :style="{ opacity: (isNaviRunning || !hasRoute) ? 0.6 : 1 }">开始</button>
                  <button class="btn clear" @click="stopSimulation" :disabled="!isNaviRunning" :style="{ opacity: !isNaviRunning ? 0.6 : 1 }">停止</button>
              </div>
              <div class="action-buttons" v-if="isNaviRunning">
                  <button class="btn" @click="pauseSimulation" :disabled="isPaused" style="background: #e6a23c; color: white;" :style="{ opacity: isPaused ? 0.6 : 1 }">暂停</button>
                  <button class="btn" @click="resumeSimulation" :disabled="!isPaused" style="background: #67c23a; color: white;" :style="{ opacity: !isPaused ? 0.6 : 1 }">继续</button>
              </div>
              
              <div class="speed-control" v-if="isNaviRunning" style="margin-top: 15px; display: flex; align-items: center; justify-content: space-between;">
                   <span style="font-size: 14px;">速度:</span>
                   <div style="display: flex; gap: 5px;">
                       <button class="btn" :style="{ background: naviSpeed === 3 ? '#409eff' : '#f4f4f5', color: naviSpeed === 3 ? 'white' : '#606266', padding: '5px 10px' }" @click="changeSpeed(3)">慢</button>
                       <button class="btn" :style="{ background: naviSpeed === 5 ? '#409eff' : '#f4f4f5', color: naviSpeed === 5 ? 'white' : '#606266', padding: '5px 10px' }" @click="changeSpeed(5)">中</button>
                       <button class="btn" :style="{ background: naviSpeed === 10 ? '#409eff' : '#f4f4f5', color: naviSpeed === 10 ? 'white' : '#606266', padding: '5px 10px' }" @click="changeSpeed(10)">快</button>
                   </div>
              </div>
              
              <div class="navi-info" v-if="isNaviRunning" style="margin-top: 15px; padding: 10px; background: #ecf5ff; border-radius: 4px; color: #409eff; text-align: center;">
                  剩余距离: {{ naviRemain }} 米
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Remove static imports to avoid dual-instance issues. 
  // We will use window.fengmap which is populated by index.html
  
  import '@/utils/fengmap/toolBarStyle.css';
  
  export default {
    name: 'MapComponent',
    created() {
        // Initialize non-reactive properties
        this.map = null;
        this.searchAnalyser = null;
        this.routeAnalyser = null;
        this.startMarker = null;
        this.endMarker = null;
        this.lineMarker = null;
        this.domMarker = null;
    },
    data() {
      return {
        // Constants
        options: {
          appName: '蜂鸟研发SDK_2_0',
          key: '57c7f309aca507497d028a9c00207cf8',
          mapID: '1514920297309614082',
          themeID: '1580453922356207618',
          level: 5,
          mapZoom: 19.5
        },
        
        // Navigation State
        naviMode: 1, // 1: Route, 2: Navigation
        floorInfos: [],
        
        start: null,
        dest: null,
        startName: '',
        endName: '',
        
        // Markers state
        clickPoint: null,
        
        routeDescription: '',
        hasRoute: false,
        
        // Simulation State
        isNaviRunning: false,
        isPaused: false,
        naviInstruction: '',
        naviRemain: 0,
        naviSpeed: 5
      }
    },
    mounted() {
      this.initMap();
    },
    beforeUnmount() {
      if (this.map) {
        this.map.dispose();
      }
    },
    methods: {
      initMap() {
        if (!document.getElementById('fengmap')) return;

        // Ensure window.fengmap is loaded
        if (!window.fengmap || !window.fengmap.FMMap) {
            console.log('Waiting for Fengmap SDK...');
            setTimeout(() => this.initMap(), 200);
            return;
        }

        const fengmap = window.fengmap;

        this.map = new fengmap.FMMap({
          container: document.getElementById('fengmap'),
          mapURL: 'https://developer.fengmap.com/fmAPI/data/',
          themeURL: 'https://developer.fengmap.com/fmAPI/data/theme/',
          ...this.options
        });

        this.map.on('loaded', () => {
          console.log('Map loaded successfully');
          this.floorInfos = this.map.getFloorInfos();
          
          this.initControls();
          this.initAnalysers();
          this.setFixedStart();
        });
        
        this.map.on('click', this.handleMapClick);
        
        this.map.on('error', (e) => {
           console.error('Map Load Error:', e);
        });
      },
      
      initControls() {
        const fengmap = window.fengmap;
        
        // Ensure UI plugin is loaded
        if (!fengmap.FMControlPosition) {
             console.log("Waiting for Fengmap UI plugin...");
             setTimeout(() => this.initControls(), 200);
             return;
        }
        
        const compass = new fengmap.FMCompass({
             position: fengmap.FMControlPosition.RIGHT_TOP,
             offset: { x: 20, y: 80 }
          });
          compass.addTo(this.map);

          const zoomBar = new fengmap.FMZoomBar({
             position: fengmap.FMControlPosition.RIGHT_TOP,
             offset: { x: 20, y: 600 }
          });
          zoomBar.addTo(this.map);
          
          const toolbar = new fengmap.FMToolbar({
             position: fengmap.FMControlPosition.RIGHT_TOP,
             floorButtonCount: 5,
             offset: { x: 20, y: 150 }
          });
          toolbar.addTo(this.map);
      },
      
      initAnalysers() {
         const fengmap = window.fengmap;
         
         // Initialize Route Analyser
         this.routeAnalyser = new fengmap.FMNaviWalkAnalyser({ map: this.map }, () => {
             console.log('Route Analyser initialized successfully');
         }, (err) => {
             console.error('Route Analyser Error:', err);
         });
         
         // Initialize Search Analyser
         this.searchAnalyser = new fengmap.FMSearchAnalyser(this.map);
      },

      findAndSetDestination(target, floorCode) {

        console.log('findAndSetDestination', target, floorCode);
          if (target.x && target.y && target.floor_id) {
              console.log('Using provided coordinates for destination:', target);
              this.setDestinationFromCoords({
                  x: target.x,
                  y: target.y,
                  level: target.floor_id,
                  name: target.name,
              });
          }
      },

      setDestinationFromCoords(coords) {
          if (this.endMarker) {
             this.endMarker.remove();
          }
          
          const fengmap = window.fengmap;
          
          this.dest = coords;
          this.endName = coords.name || '目的地';
          console.log('Destination set:', this.dest);

          // 延时执行，确保地图加载完成
          setTimeout(() => {
              this.endMarker = new fengmap.FMImageMarker({
                  x: this.dest.x,
                  y: this.dest.y,
                  url: 'https://developer.fengmap.com/fmAPI/images/navi/end.png'
              });
              
              const floor = this.map.getFloor(this.dest.level);
              if (floor) {
                  this.endMarker.addTo(floor);
              } else {
                  console.warn('Destination floor not found:', this.dest.level);
              }
              // Switch to Route Planning Mode
              this.naviMode = 1;
              
              // If start exists, plan route
              if (this.start) {
                  this.naviAndDrawLine();
              }
          }, 800); // 延时500ms确保地图加载完成
          
          
      },

      setDestinationFromModel(model) {
          if (!model) return;
          
          if (this.endMarker) {
              this.endMarker.remove();
          }
          
          const fengmap = window.fengmap;
          
          // Use model center or mapCoord
          const coord = model.mapCoord || { x: model.x, y: model.y, z: model.z, level: model.groupID };

          this.dest = { ...coord, level: model.groupID, name: model.name };
          this.endName = model.name;
          
          this.endMarker = new fengmap.FMImageMarker({
            x: this.dest.x,
            y: this.dest.y,
            url: 'https://developer.fengmap.com/fmAPI/images/navi/end.png'
         });
          
          const floor = this.map.getFloor(this.dest.level);
          this.endMarker.addTo(floor);
          
          // Switch to Route Planning Mode
          this.naviMode = 1;
          
          // If start exists, plan route
          if (this.start) {
              this.naviAndDrawLine();
          } else {
              // Optional: Set current location as start if available? 
              // For now just wait for user to pick start
          }
      },

      setFixedStart() {
         // user specified fixed start point for the big screen
         // Coordinates: X:12961600 Y:4861800 Level: 5
         
         const fengmap = window.fengmap;
         if (!this.map) return;
         
         // Fixed coordinates provided by user
         const fixedX = 11791504.881715;
         const fixedY = 3418779.751;
         const fixedLevel = 5; // User specified level 5
         
         console.log('Fixed Start Config:', { x: fixedX, y: fixedY, level: fixedLevel });
         
         this.start = {
             x: fixedX,
             y: fixedY,
             level: fixedLevel,
             name: '当前位置'
         };
         this.startName = this.start.name;
         
         // Draw start marker
         if (this.startMarker) this.startMarker.remove();
         
         this.startMarker = new fengmap.FMImageMarker({
             x: this.start.x,
             y: this.start.y,
             url: 'https://developer.fengmap.com/fmAPI/images/navi/start.png',
         });
         
         const floor = this.map.getFloor(this.start.level);
         if (floor) {
              this.startMarker.addTo(floor);
         } else {
              console.warn('Could not find floor for fixed start level:', fixedLevel);
         }
      },
      
      handleMapClick(e) {
        if (this.domMarker) {
            this.domMarker.remove();
            this.domMarker = null;
        }

        if (!e.level) return;
        
        const fengmap = window.fengmap;
        
        const model = e.targets.find(item => item.type === fengmap.FMType.MODEL);
        if (model) {
            this.clickPoint = { 
                level: e.level, 
                x: model.x, 
                y: model.y, 
                z: model.z,
                name: model.name || '未知位置',
                id: model.fid 
            };
            this.showDomMarker(this.clickPoint);
        }
      },
      
      showDomMarker(position) {
        // We need to create a DOM element for the marker content
        // Since we are in Vue, we can't easily use Vue templates inside the raw DOM marker content string
        // So we use standard DOM API or HTML string
        
        const contentHTML = `
            <div style="display: inline-block; width: 200px; text-align: center;">
                <div style="display: flex; margin-bottom: 10px; border-radius: 6px; background-color: white; box-shadow: 0 2px 10px rgba(0,0,0,0.2);">
                    <div id="btn-set-start" style="flex: 1; height: 36px; line-height: 36px; cursor: pointer; color: #333; border-right: 1px solid #eee;">设为起点</div>
                    <div id="btn-set-end" style="flex: 1; height: 36px; line-height: 36px; cursor: pointer; color: #333;">设为终点</div>
                </div>
                <div style="width: 0; height: 0; border-left: 10px solid transparent; border-right: 10px solid transparent; border-top: 10px solid white; margin: 0 auto;"></div>
            </div>
        `;

        const fengmap = window.fengmap;

        this.domMarker = new fengmap.FMDomMarker({
            x: position.x,
            y: position.y,
            z: position.z || 0,
            domHeight: 60,
            domWidth: 200,
            anchor: fengmap.FMMarkerAnchor.BOTTOM,
            content: contentHTML
        });

        const floor = this.map.getFloor(position.level);
        this.domMarker.addTo(floor);
        
        // Bind click events after adding to DOM
        // Need to wait for next tick or use a timeout to ensure DOM is rendered
        setTimeout(() => {
            const startBtn = document.getElementById('btn-set-start');
            const endBtn = document.getElementById('btn-set-end');
            
            if (startBtn) startBtn.onclick = (e) => { e.stopPropagation(); this.setStart(); };
            if (endBtn) endBtn.onclick = (e) => { e.stopPropagation(); this.setEnd(); };
        }, 100);
      },
      
      setStart() {
         if (!this.clickPoint) return;
         
         if (this.startMarker) {
             this.startMarker.remove();
         }
         
         const fengmap = window.fengmap;

         this.start = { ...this.clickPoint };
         this.startName = this.clickPoint.name;
         
         this.startMarker = new fengmap.FMImageMarker({
            x: this.start.x,
            y: this.start.y,
            url: 'https://developer.fengmap.com/fmAPI/images/navi/start.png'
         });
         
         const floor = this.map.getFloor(this.start.level);
         this.startMarker.addTo(floor);
         
         if (this.domMarker) {
            this.domMarker.remove();
            this.domMarker = null;
         }
         
         // Auto plan if end exists
         if (this.dest) {
             this.naviAndDrawLine();
         }
      },
      
      setEnd() {
         if (!this.clickPoint) return;
         
         if (this.endMarker) {
             this.endMarker.remove();
         }
         
         const fengmap = window.fengmap;

         this.dest = { ...this.clickPoint };
         this.endName = this.clickPoint.name;
         console.log('Destination set:', this.dest);
         this.endMarker = new fengmap.FMImageMarker({
            x: this.dest.x,
            y: this.dest.y,
            url: 'https://developer.fengmap.com/fmAPI/images/navi/end.png'
         });
         
         const floor = this.map.getFloor(this.dest.level);
         this.endMarker.addTo(floor);
         
         if (this.domMarker) {
            this.domMarker.remove();
            this.domMarker = null;
         }
         
         // Auto plan if start exists
         if (this.start) {
             this.naviAndDrawLine();
         }
      },
      
      exchangeStartEnd() {
          if (!this.start || !this.dest) return;
          
          const tempStart = { ...this.start };
          const tempDest = { ...this.dest };
          // const tempStartName = this.startName;
          // const tempEndName = this.endName;
          
          // Clear current
          this.clearAll();
          
          // Swap logic manually to reuse set functions
          this.clickPoint = tempDest;
          this.setStart();
          
          this.clickPoint = tempStart;
          this.setEnd();
      },
      
      naviAndDrawLine() {
          if (!this.start || !this.dest) {
              return;
          }
          
          // Stop simulation if running to avoid conflicts
          if (this.isNaviRunning) {
              this.stopSimulation();
          }
          
          if (!this.routeAnalyser) {
              console.warn('Route Analyser not ready');
              return;
          }
          
          // Clean previous line
          if (this.lineMarker) {
              this.lineMarker.remove();
              this.lineMarker = null;
          }
          
          const request = {
              start: {
                  x: this.start.x,
                  y: this.start.y,
                  level: this.start.level
              },
              dest: {
                  x: this.dest.x,
                  y: this.dest.y,
                  level: this.dest.level
              },
              mode: window.fengmap.FMNaviMode.MODULE_SHORTEST,
              priority: window.fengmap.FMNaviPriority.PRIORITY_LIFTFIRST
          };
          
          console.log('Planning Route with Request:', request);
          
          this.routeAnalyser.route(request, (result) => {
              console.log('Route Result:', result);
              if (!result || !result.subs || result.subs.length === 0) {
                  this.routeDescription = '无法规划路线';
                  this.hasRoute = false;
                  return;
              }
              
              const distance = result.distance.toFixed(1);
              const time = (distance / 80).toFixed(1); // 80m/min
              this.routeDescription = `距离: ${distance}米, 预计耗时: ${time}分钟`;
              this.hasRoute = true;
              
              this.drawLine(result);
          }, (err) => {
              console.error('Route Analysis Error:', err);
              console.error('Request params that failed:', request);
              this.routeDescription = '规划失败: ' + err;
              this.hasRoute = false;
          });
      },
      
      drawLine(result) {
          const fengmap = window.fengmap;
          
          const segments = [];
          let subs = result.subs;
          let segment = new fengmap.FMSegment();
          
          for (let index = 0; index < subs.length; index++) {
              const leg = subs[index];
              if (leg.levels[0] === leg.levels[1]) {
                  // If it's the same floor
                  // Adjust z-index slightly to avoid z-fighting if needed
                  leg.waypoint.points.forEach(point => {
                      point.z = 1; // Lift line slightly above floor
                  });
                  
                  if (segment.points) {
                      let points = [];
                      points.push(...leg.waypoint.points);
                      // Remove duplicate connection point
                      points.splice(0, 1);
                      segment.points = segment.points.concat(points);
                  } else {
                      segment.points = leg.waypoint.points;
                  }
                  segment.groupId = leg.levels[0]; // Set group ID (floor)
                  // Try setting both to be safe, router.html uses .level
                  segment.level = leg.levels[0];
                  
                  if (index === subs.length - 1) {
                      segments.push(segment);
                  }
              } else {
                  // Cross floor
                  segments.push(segment);
                  segment = new fengmap.FMSegment();
              }
          }
          
          console.log('Drawing Line with Segments:', segments);

          this.lineMarker = new fengmap.FMLineMarker({
             segments: segments,
             width: 4,
             color: '#0099FF',
             mode: fengmap.FMLineMarker.FMLINE_CIRCLE,
             smooth: true
          });
          
          this.lineMarker.addTo(this.map);
      },
      
      clearAll() {
          this.stopSimulation();
          
          if (this.startMarker) {
              this.startMarker.remove();
              this.startMarker = null;
          }
          if (this.endMarker) {
              this.endMarker.remove();
              this.endMarker = null;
          }
          if (this.lineMarker) {
              this.lineMarker.remove();
              this.lineMarker = null;
          }
          if (this.domMarker) {
              this.domMarker.remove();
              this.domMarker = null;
          }
          
          this.start = null;
          this.dest = null;
          this.startName = '';
          this.endName = '';
          this.routeDescription = '';
          this.hasRoute = false;
      },
      
      createNavi() {
        // Always create a new instance to ensure clean state
        if (this.navi) {
            this.navi.stop();
            this.navi.clearAll();
            this.navi = null;
        }

        console.log("Creating Navigation Instance...");
        const FMNavigationWalk = window.fengmap.FMNavigationWalk;
        if (!FMNavigationWalk) {
            console.error("FMNavigationWalk not found in window.fengmap");
            return null;
        }

        try {
            const navi = new FMNavigationWalk({
                map: this.map,
                analyser: this.routeAnalyser,
                locationMarkerUrl: 'https://developer.fengmap.com/fmAPI/images/bluedot-arrow.png',
                locationMarkerSize: 48,
                speed: this.naviSpeed,
                followPosition: true,
                followAngle: true,
                changeTiltAngle: true,
                zoom: 20,
                lineMarkerHeight: 0.5
            });
            
            navi.on('walking', (data) => {
                this.updateNaviInfo(data);
            });
            
            navi.on('complete', () => {
                console.log("Navigation complete");
                this.isNaviRunning = false;
                this.isPaused = false;
                this.naviInstruction = '到达终点';
            });
            
            this.navi = navi;
            return navi;
        } catch (e) {
            console.error("Error creating FMNavigationWalk:", e);
            return null;
        }
    },
    
    handleStartSimulation() {
        this.naviMode = 2;
        this.$nextTick(() => {
            this.startSimulation();
        });
    },

    startSimulation() {
        console.log("Starting Simulation...");
        if (!this.hasRoute) {
            alert("请先规划路线");
            return;
        }
        
        // Create fresh navigation instance
        if (!this.createNavi()) {
            return;
        }
        
        // Use the start/dest from component state
        const startOption = {
            x: this.start.x,
            y: this.start.y,
            level: this.start.level,
            url: 'https://developer.fengmap.com/fmAPI/images/navi/start.png',
            size: 32
        };
        const destOption = {
            x: this.dest.x,
            y: this.dest.y,
            level: this.dest.level,
            url: 'https://developer.fengmap.com/fmAPI/images/navi/end.png',
            size: 32
        };

        console.log("Setting Start/Dest for Navi:", startOption, destOption);

        try {
            this.navi.setStartPoint(startOption);
            this.navi.setDestPoint(destOption);
        } catch (e) {
             console.error("Error setting start/dest points:", e);
             return;
        }
        
        console.log("Routing for Navi...");
        // Recalculate route for navi (it needs its own internal path)
        this.navi.route({
            mode: window.fengmap.FMNaviMode.MODULE_SHORTEST,
            priority: window.fengmap.FMNaviPriority.PRIORITY_LIFTFIRST
        }, (result) => {
            console.log("Navi Route Result:", result);
            try {
                // Remove the static line from route planning so it doesn't overlap
                if (this.lineMarker) {
                    this.lineMarker.remove();
                    this.lineMarker = null;
                }

                // Draw the navigation line (which automatically updates/shortens)
                this.navi.drawNaviLine();

                const simulateOptions = {
                    speed: this.naviSpeed,
                    followPosition: true,
                    followAngle: true,
                    changeTiltAngle: true,
                    zoom: 20,
                    maxZoom: 22
                };

                this.navi.simulate(simulateOptions);
                // Ensure speed is set
                this.navi.setSpeed(this.naviSpeed);
                
                this.isNaviRunning = true;
                this.isPaused = false;
                console.log("Simulation started");
            } catch (e) {
                console.error("Error calling navi.simulate():", e);
            }
        });
    },
    
    pauseSimulation() {
        if (this.navi) {
            this.navi.pause();
            this.isPaused = true;
        }
    },
    
    resumeSimulation() {
        if (this.navi) {
            this.navi.resume();
            this.isPaused = false;
        }
    },
    
    stopSimulation() {
        if (this.navi) {
            this.navi.stop();
            this.navi.clearAll(); // Clear navi markers
        }
        this.isNaviRunning = false;
        this.isPaused = false;
        this.naviInstruction = '';
    },
    
    changeSpeed(speed) {
        this.naviSpeed = speed;
        if (this.navi) {
            this.navi.setSpeed(speed);
        }
    },
    
      updateNaviInfo(data) {
          this.naviRemain = data.remain.toFixed(1);
          
          if (this.navi && this.navi.naviResult && this.navi.naviResult.subs) {
              const sub = this.navi.naviResult.subs[data.index];
              if (sub && sub.instruction) {
                  this.naviInstruction = sub.instruction.zh || sub.instruction;
              }
          }
      }
    }
  }
</script>

<style scoped>
/* @import url("https://developer.fengmap.com/fmAPI/demos/libs/css/index.css"); */

.map-container {
  width: 100%;
  height: 100%;
  position: relative;
  background: #f0f0f0;
}

#fengmap {
  width: 100%;
  height: 100%;
}

.panel {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 320px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 100;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.panel-header {
  display: flex;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}

.panel-header span {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
}

.panel-header span.active {
  color: #409eff;
  font-weight: bold;
  background: white;
  border-bottom: 2px solid #409eff;
}

.panel-content {
  padding: 20px;
}

.start-end-input {
  position: relative;
  margin-bottom: 20px;
}

.input-group {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  background: #f5f7fa;
  border-radius: 4px;
  padding: 8px;
}

.input-group input {
  border: none;
  background: transparent;
  width: 100%;
  margin-left: 8px;
  outline: none;
  font-size: 14px;
  color: #333;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.dot.start {
  background: #67c23a;
  border: 2px solid #e1f3d8;
}

.dot.end {
  background: #f56c6c;
  border: 2px solid #fde2e2;
}

.exchange-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  color: #909399;
  font-size: 16px;
}

.action-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.btn {
  flex: 1;
  padding: 10px 0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.btn.clear {
  background: #f4f4f5;
  color: #909399;
}

.btn.clear:hover {
  background: #e9e9eb;
}

.btn.search {
  background: #409eff;
  color: white;
}

.btn.search:hover {
  background: #66b1ff;
}

.route-info {
  background: #ecf5ff;
  color: #409eff;
  padding: 10px;
  border-radius: 4px;
  font-size: 13px;
  text-align: center;
}
</style>